<template>
    <modal name="edit-user" :scrollable="true" :height="'auto'" :clickToClose="false">
        <div class="container p-5 modal-content-rounded">
            <div class="text-center mb-4">
                <h3 class="with-lines">Editar Usuario {{ nombre }}</h3>
            </div>
            <div class="row p-1 mr-1">
                <label class="col-sm-2 col-form-label">Rol</label>
                <select class="form-select form-select-sm col-sm-10 diferentInput" v-model="rol" @change="emitChange('rol', rol)">
                    <option value="20040">ADMINISTRADOR</option>
                    <option value="20167">ANALISTA</option>
                    <!-- <option value="20056">PROVEEDOR</option> -->
                </select>
            </div>
            <div class="p-1">
                <div class="row">
                    <label class="col-sm-2 col-form-label">Nombre</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" v-model="nombre" @input="emitChange('nombre', nombre)" >
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-2 col-form-label">Usuario</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" v-model="user" @input="emitChange('user', user)" disabled>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-2 col-form-label">Contraseña</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input :type="passwordFieldType1" class="form-control diferentInput" v-model="password" @input="emitChange('password', password)">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="togglePasswordVisibility('passwordFieldType1')">
                            <i :class="passwordFieldType1 === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-2 col-form-label">Confirmar contraseña</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input :type="passwordFieldType2" class="form-control diferentInput" v-model="confirmPassword" @input="emitChange('confirmPassword', confirmPassword)">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="togglePasswordVisibility('passwordFieldType2')">
                            <i :class="passwordFieldType2 === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-2 col-form-label">Email</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" v-model="email" @input="validateEmail($event)">
                        <span class="invalidEmail col-12" v-if="!validEmail">Por favor, introduce un correo electrónico válido.</span>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-3"></div>
                <div class="col-md-4 float-right">
                    <button class="btn btn-danger float-right" style="border-radius: 15px;" @click="closeModal"><i class="fas fa-times-circle mr-2"></i>Cerrar</button>
                </div>
                <div class="col-md-5 float-right">
                    <button class="btn btn-primary float-right" @click="editarUsuario"><i class="fas fa-plus mr-2"></i>Guardar cambios</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    props: {
        editarUsuario: Function,
        nombre: String,
        email: String,
        user: String,
        password: String,
        confirmPassword: String,
        rol: Number,
    },
    data() {
        return { 
            passwordFieldType1: 'password',
            passwordFieldType2: 'password',
            validEmail: true,
        }
    },
    watch: {
        cleanModal(value) {
            if (value) {
                this.limpiarControles();
            }
        },
    },
    methods:{
        emitChange(prop, value) {
            this.$emit(`update:${prop}`, value);
            this.$emit('field-changed', { prop, value }); // Emitimos un evento general para cualquier cambio
        },
        togglePasswordVisibility(field) {
            this[field] = this[field] === 'password' ? 'text' : 'password';
        },
        validateEmail(event) {
            const email = event.target.value;
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            this.validEmail = emailPattern.test(email);
            this.email = email;
            this.emitChange('email', email);
        }, 
        closeModal(){
            this.$modal.hide('edit-user');
            this.$emit('update:nombre', '');
            this.$emit('update:user', '');
            this.$emit('update:email', '');
            this.$emit('update:rol', '');
            this.validEmail = true;
            this.passwordFieldType1 = 'password';
            this.passwordFieldType2 = 'password';
        }
    },
    mounted() {
    },
}
</script>
<style>
.btn-outline-secondary{
    border-color: #ffffff;
    margin-bottom: 20px;
}
.modal-content-rounded {
  border-radius: 15px; /* Ajusta el valor según tus necesidades */
}
.diferentInput{
  border: none;
  border-bottom: 2px solid rgba(128, 128, 128, 0.568);
}
h3{
    color: #003c717a;
}
.with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.with-lines::before,
.with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #003c717a;
    margin: 0 10px;
}
.invalidEmail{
    font-size: small;
    color: red;
}
.file-select {
    position: relative;
    display: inline-block;
    width: 330px;
    height: 30px;
    margin-right: 20px;
    cursor: pointer;
    /* Añade un borde alrededor del elemento */
    border: 1px solid #cccccca6;
    border-radius: 5px;

}

.file-select::before {
    background-color: #ffffff;
    color: rgba(153, 152, 152, 0.548);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: small;
    content: "Seleccionar archivo";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.col-md-6, .col-md-5, .col-md-3, .col-md-4 {
    padding-right: 7px !important;
    padding-left: 7px !important;
}
.btn-primary{
    background-image: linear-gradient(to right, #085da8, #003c71);
    border-radius: 15px !important;
}
.btn-secondary{
    background-color: #276E90 !important;
    border-color: #276E90 !important;
    color: white;
}
.vm--modal {
  border-radius: 30px !important;
  }
  .vue-js-modal .v--modal-box {
  border-radius: 15px; /* Ajusta el valor según tus necesidades */
  overflow: hidden; /* Para que el contenido no sobresalga de las esquinas redondeadas */
}
</style>